export var RestoreMethodAvailabilityReason;
(function (RestoreMethodAvailabilityReason) {
    RestoreMethodAvailabilityReason["RESTORE_METHOD_NOT_SPECIFIED"] = "RESTORE_METHOD_NOT_SPECIFIED";
    RestoreMethodAvailabilityReason["RESTORE_METHOD_HAS_LSI"] = "RESTORE_METHOD_HAS_LSI";
    RestoreMethodAvailabilityReason["RESTORE_METHOD_SIZE_LIMIT"] = "RESTORE_METHOD_SIZE_LIMIT";
})(RestoreMethodAvailabilityReason || (RestoreMethodAvailabilityReason = {}));
